export class DlsgPolicyFilters {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "_in",
            "baseName": "in",
            "type": "Array<string>",
            "format": ""
        },
        {
            "name": "notIn",
            "baseName": "notIn",
            "type": "Array<string>",
            "format": ""
        },
        {
            "name": "containsAnyOf",
            "baseName": "containsAnyOf",
            "type": "Array<string>",
            "format": ""
        },
        {
            "name": "containsNoneOf",
            "baseName": "containsNoneOf",
            "type": "Array<string>",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return DlsgPolicyFilters.attributeTypeMap;
    }
    constructor() {
    }
}
